export const question_vn = [
  {
    survey_group_id: 2.0,
    survey_country_id: 'VN',
    choice_vn: [
      {value: 'Có', type: 'label'},
      {value: 'Không', type: 'label'}
    ],
    choice_en: [
      {value: 'Yes', type: 'label'},
      {value: 'No', type: 'label'}
    ],
    question_vn: 'Bạn có hài lòng với giấy photocopy cao cấp Double A không?',
    question_en: 'Are you satisfied with Double A Premium copy paper?',
    question_number: 1.0,
    question_type: 'single'
  },
  {
    survey_group_id: 2.0,
    survey_country_id: 'VN',
    choice_vn: [
      {value: 'Chất lượng cao cấp và ổn định', type: 'label'},
      {value: 'Bề mặt láng mịn', type: 'label'},
      {value: 'Chất lượng tốt để in 2 mặt', type: 'label'},
      {value: 'Giấy dày', type: 'label'},
      {value: 'Giấy trắng', type: 'label'}
    ],
    choice_en: [
      {value: 'Premium and stable quality', type: 'label'},
      {value: 'Smooth surface', type: 'label'},
      {value: 'High opacity', type: 'label'},
      {value: 'Thickness', type: 'label'},
      {value: 'Whiteness', type: 'label'}
    ],
    question_vn: 'Lý do gì làm bạn hài lòng với giấy Double A? (có thể chọn nhiều câu trả lời)',
    question_en:
      'What are the reasons you satisfied with Double A? (You can choose more than one answers)',
    question_number: 2.0,
    question_type: 'multiple'
  },
  {
    survey_group_id: 2.0,
    survey_country_id: 'VN',
    choice_vn: [
      {value: 'Double A', type: 'label'},
      {value: 'Nhãn hiệu khác. Vui lòng ghi rõ:', type: 'textbox'},
      {value: 'Cả 2', type: 'label'}
    ],
    choice_en: [
      {value: 'Double A', type: 'label'},
      {value: 'Other brands, please specify', type: 'textbox'},
      {value: 'Both', type: 'label'}
    ],
    question_vn: 'Trước khi tham gia chương trình QR code này, bạn có dùng giấy Double A hoặc giấy nhãn hiệu khác không?',
    question_en:
      'Before joining Double A QR code program, did you use Double A or other brands?',
    question_number: 3.0,
    question_type: 'single'
  },
  {
    survey_group_id: 2.0,
    survey_country_id: 'VN',
    choice_vn: [
      {value: 'Không hài lòng với nhãn hiệu khác', type: 'label'},
      {value: 'Được nhà cung cấp giới thiệu', type: 'label'},
      {value: 'Vì chương trình QR code của Double A', type: 'label'},
      {value: 'Sản phẩm chất lượng cao', type: 'label'},
      {value: 'Dễ dàng mua hàng ở mọi nơi', type: 'label'},
      {value: 'Giá hợp lý', type: 'label'}
    ],
    choice_en: [
      {value: 'Not satisfied with other brands', type: 'label'},
      {value: 'Recommended by supplier', type: 'label'},
      {value: 'Double A QR code program', type: 'label'},
      {value: 'High quality product', type: 'label'},
      {value: 'Easy to purchase anywhere', type: 'label'},
      {value: 'Price is reasonable', type: 'label'}
    ],
    question_vn: 'Lý do gì bạn đổi sang dùng giấy photocopy cao cấp Double A? (có thể chọn nhiều câu trả lời)',
    question_en:
      'What are the reasons you changed to use Double A Premium copy paper?',
    question_number: 4.0,
    question_type: 'multiple'
  },
  {
    survey_group_id: 2.0,
    survey_country_id: 'VN',
    choice_vn: [
      {value: 'Hơn 10 năm', type: 'label'},
      {value: '6-10 năm', type: 'label'},
      {value: '2-5 năm', type: 'label'},
      {value: 'Không quá 1 năm', type: 'label'}
    ],
    choice_en: [
      {value: 'More than 10 years', type: 'label'},
      {value: '6-10 years', type: 'label'},
      {value: '2-5 years', type: 'label'},
      {value: '1 year or less', type: 'label'}
    ],
    question_vn: 'Bạn đã dùng giấy photocopy cao cấp Double A bao lâu?',
    question_en: 'How long have you been using Double A Premium copy paper?',
    question_number: 5.0,
    question_type: 'single'
  },
  {
    survey_group_id: 2.0,
    survey_country_id: 'VN',
    choice_vn: [
      {value: 'Grab Food', type: 'label'},
      {value: "Shopee", type: 'label'},
      {value: 'Tiki', type: 'label'},
      {value: 'KFC', type: 'label'},
      {value: 'Loại khác. Vui lòng ghi rõ:', type: 'textbox'}
    ],
    choice_en: [
      {value: 'Grab Food', type: 'label'},
      {value: "Shopee", type: 'label'},
      {value: 'Tiki', type: 'label'},
      {value: 'KFC', type: 'label'},
      {value: 'Others, please specify', type: 'textbox'}
    ],
    question_vn: 'Phiếu mua hàng điện tử nào bạn thích nhất?',
    question_en: 'Which e-voucher would you prefer the most?',
    question_number: 6.0,
    question_type: 'single'
  }
];
